<div *ngIf="!!this.formularzLokalizacjiUszkodzenia" class="container">
    <div class="row">
        <div class="col-12" [formGroup]="formularzLokalizacjiUszkodzenia">

            <div class="module-section__name mt-5">
                <span>{{opisWspoldzielonychParametrow}}</span>
            </div>

            <div class="o-flex o-flex--grids mt-4">

                <div *ngIf="pokazSzerokosc" class="o-flex__item u-flex-1/4@tablet u-flex-1/1@small">
                    <label class="c-label">
                        <span class="c-label__title" [class.text-danger]="SZEROKOSC.errors && (SZEROKOSC.touched || SZEROKOSC.dirty)">Szerokość (m)</span>
                        <input id='szerokoscLokalizacji' formControlName="szerokosc" type="number" class="c-input" value="" title="">
                        <span class="c-label__title text-danger u-margin-right-tiny" *ngIf="SZEROKOSC.errors && (SZEROKOSC.touched || SZEROKOSC.dirty)">
                            Dane powinny być z zakresu od {{ this.minimalnyWymiar | number:'':language }} do {{ this.maksymalnyWymiar | number:'':language }}
                        </span>
                    </label>
                </div>

                <div *ngIf="pokazDlugosc" class="o-flex__item u-flex-1/4@tablet u-flex-1/1@small">
                    <label class="c-label">
                        <span class="c-label__title" [class.text-danger]="DLUGOSC.errors && (DLUGOSC.touched || DLUGOSC.dirty)">Długość (m)</span>
                        <input id='dlugoscLokalizacji' formControlName="dlugosc" type="number" class="c-input" value="" title="">
                        <span *ngIf="DLUGOSC.errors && (DLUGOSC.touched || DLUGOSC.dirty)" class="c-label__title text-danger u-margin-right-tiny">
                            Dane powinny być z zakresu od {{ this.minimalnyWymiar | number: '':language }} do {{ this.maksymalnyWymiar | number: '':language }}
                        </span>
                    </label>
                </div>

                <div *ngIf="pokazWysokosc" class="o-flex__item u-flex-1/4@tablet u-flex-1/1@small">
                    <label class="c-label">
                        <span class="c-label__title" [class.text-danger]="WYSOKOSC.errors && (WYSOKOSC.touched || WYSOKOSC.dirty)">Wysokość (m)</span>
                        <input id='wysokoscLokalizacji' formControlName="wysokosc" type="number" class="c-input" value="" title="">
                        <span *ngIf="WYSOKOSC.errors && (WYSOKOSC.touched || WYSOKOSC.dirty)" class="c-label__title text-danger u-margin-right-tiny">
                            Dane powinny być z zakresu od {{ this.minimalnyWymiar | number: '':language }} do {{ this.maksymalnyWymiar | number: '':language }}
                        </span>
                    </label>
                </div>

                <div *ngIf="pokazLiczbePieter" class="o-flex__item u-flex-1/4@tablet u-flex-1/1@small">
                    <label class="c-label">
                        <span [class.text-danger]="LICZBA_PIETER.errors && (LICZBA_PIETER.touched || LICZBA_PIETER.dirty)" class="c-label__title">Liczba kondygnacji</span>
                        <input id='liczbaPieter' formControlName="liczbaPieter" type="number" class="c-input" value="" title="" appNumbersOnly>
                        <span *ngIf="LICZBA_PIETER.errors && (LICZBA_PIETER.touched || LICZBA_PIETER.dirty)" class="c-label__title text-danger u-margin-right-tiny">
                            Liczba kondygnacji powinna być wartością całkowitą z przedziału od {{ this.minimalnaLiczbaKondygnacji }} do {{ this.maksymalnaLiczbaKondygnacji }}
                        </span>
                    </label>
                </div>

                <div *ngIf="pokazRokRemontu && czyDataRemontuWymagana" class="o-flex__item u-flex-1/4@tablet u-flex-1/1@small">
                    <label class="c-label">
                      <span class="c-label__title" [class.text-danger]="formularzLokalizacjiUszkodzenia?.get('dataRemontu')?.errors && formularzLokalizacjiUszkodzenia?.get('dataRemontu')?.touched">Data remontu (mm/rrrr)</span>
                        <shared-datepicker-yearmonth
                                (focusout)="formularzLokalizacjiUszkodzenia?.get('dataRemontu')?.markAsTouched()"
                                formControlName="dataRemontu"
                                [minDate]="minimalnyRokRemontu"
                                [maxDate]="maksymalnyRokRemontu"
                        ></shared-datepicker-yearmonth>
                      <span *ngIf="formularzLokalizacjiUszkodzenia?.get('dataRemontu')?.errors && formularzLokalizacjiUszkodzenia?.get('dataRemontu')?.touched"
                            class="c-label__title text-danger u-margin-right-tiny">Ta informacja jest obowiązkowa</span>
                    </label>
                </div>

            </div>

        </div>
    </div>
</div>
